<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list v-if ="dataList && dataList.length >0" v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad" :immediate-check="false">
      <van-cell v-for="(item,index) in dataList" :key="index" :border="false">
        <template #default>
          <slot name="row" :index="index" :row="item"></slot>
        </template>
      </van-cell>
    </van-list>
    <van-empty v-else description="暂无数据" />
  </van-pull-refresh>
</template>

<script>
import { PageMixin } from '@/mixins/PageMixin'
export default {
  name: 'PageList',
  props: {
    requestUrl: String,
    getParams: {
      type: Function,
      default: null
    },
    preprocessData: {
      type: Function,
      required: false,
      default: null
    }
  },
  mixins: [PageMixin],
  data () {
    return {
      url: {
        list: this.requestUrl
      }
    }
  },
  methods: {
    getQueryParams () {
      const params = Object.assign(this.queryParams, { pageNum: this.pageNo, pageSize: this.pageSize })
      if (this.getParams === null) {
        return params
      }
      return this.getParams(params)
    },
    processResult (res) {
      if (res.code === 200) {
        const { data, page } = res
        this.total = page.total
        if (page.pageNum >= page.pages) {
          this.finished = true
        }

        if (page.pageNum === 1) {
          this.dataList = []
          this.finished = false
        }
        if (this.preprocessData != null) {
          this.preprocessData(data)
        }
        this.dataList = this.dataList.concat(data)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .van-cell {
    padding: 10px 32px;
  }
</style>
